<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: rgba(3, 0, 108, 1);
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgba(3, 0, 108, 1);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorWorshop .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorWorshop .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorWorshop .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
.yongxinBigTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/big_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
<template>
  <div style="display: inline;">
    <div ref="container" class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;">
      <div ref="header" class="yongxinBigTitle" style="height:66px;width:100%;display: flex;justify-content: center;align-items: center;color: white;font-weight: bold;font-size: 30px;">
        <p>能耗综合看板</p>
      </div>
      <div style="margin-top: 20px;">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :is-draggable="false" :is-resizable="false" :row-height="gridRowHeihgt" :is-mirrored="false" :vertical-compact="false" :margin="[0, 0]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: hidden;">
          <grid-item @resized="resizedGrid" v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component :cockpitData="cockpitData" :ref="'grid_' + item.i" v-bind:is="item.i" :orgId="orgId"> </component>
          </grid-item>
        </grid-layout>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from 'vue-grid-layout';
import device_seven_top5 from '@@/pages/web/customize/yongxin/monitor/mes/energy/device_seven_top5';
import device_thirty_top5 from '@@/pages/web/customize/yongxin/monitor/mes/energy/device_thirty_top5';
import device_seven_trend from '@@/pages/web/customize/yongxin/monitor/mes/energy/device_seven_trend';
import device_thirty_ratio from '@@/pages/web/customize/yongxin/monitor/mes/energy/device_thirty_ratio';
import device_today_ratio from '@@/pages/web/customize/yongxin/monitor/mes/energy/device_today_ratio';
import sum from '@@/pages/web/customize/yongxin/monitor/mes/energy/sum';

export default {
  name: 'web_monitor_energy_index',
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    device_seven_top5: device_seven_top5,
    device_thirty_top5: device_thirty_top5,
    device_seven_trend: device_seven_trend,
    device_today_ratio: device_today_ratio,
    device_thirty_ratio: device_thirty_ratio,
    sum: sum
  },

  data() {
    return {
      isEditingTemplate: false,
      isShowBoardEdit: false,
      orgId: this.store.state.organizations[0].id,
      cockpitData: {},
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: []
    };
  },
  watch: {
    orgId(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getCockpit();
    }
  },
  created() {
    this.setLayout();

    this.timmer = setInterval(() => {
      this.getCockpit();
    }, 120000);
    this.getCockpit();
  },
  activated() {
    this.resize();
  },

  mounted() {
    setInterval(() => {
      console.log(this.layout);
    }, 5000);
    this.resize();
    this.utils.event_hub.$on('SetLayoutCockpit', () => {
      this.setLayout();
    });
    this.utils.event_hub.$on('BeginEditCockpit', () => {
      this.isEditingTemplate = true;
      this.isShowBoardEdit = false;
    });
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
    this.utils.event_hub.$off('SetLayoutCockpit');
    this.utils.event_hub.$off('BeginEditCockpit');

    if (this.timmer) {
      clearInterval(this.timmer);
    }
  },
  methods: {
    setLayout() {
      this.layout = [
        {
          x: 0,
          y: 0,
          w: 6,
          h: 12, //应该是6
          i: 'device_seven_top5'
        },
        {
          x: 6,
          y: 0,
          w: 12,
          h: 12, //应该是6
          i: 'sum'
        },
        {
          x: 18,
          y: 0,
          w: 6,
          h: 12,
          i: 'device_today_ratio'
        },
        {
          x: 0,
          y: 12,
          w: 6,
          h: 12, //应该是6
          i: 'device_thirty_top5'
        },
        {
          x: 6,
          y: 12,
          w: 12,
          h: 12, //应该是6
          i: 'device_seven_trend'
        },
        {
          x: 18,
          y: 12,
          w: 6,
          h: 12, //应该是6
          i: 'device_thirty_ratio'
        }
      ];

      this.$nextTick(() => {
        this.utils.event_hub.$emit('RESIZE');
      });
    },
    async getCockpit() {
      let response = await this.http.get('/web/energy/consumption/data/board/dataSummary', {
        params: {
          orgId: this.orgId
        }
      });
      this.$set(this.cockpitData, 'sum', response.data);

      let response2 = await this.http.get('/web/energy/consumption/data/board/top5In7', {
        params: {
          orgId: this.orgId
        }
      });
      this.$set(this.cockpitData, 'top5In7', response2.data);

      let response3 = await this.http.get('/web/energy/consumption/data/board/top5In30', {
        params: {
          orgId: this.orgId
        }
      });
      this.$set(this.cockpitData, 'top5In30', response3.data);

      let response4 = await this.http.get('/web/energy/consumption/data/board/top5InToday', {
        params: {
          orgId: this.orgId
        }
      });
      this.$set(this.cockpitData, 'top5InToday', response4.data);

      let response5 = await this.http.get('/web/energy/consumption/data/board/trendIn7', {
        params: {
          orgId: this.orgId
        }
      });
      this.$set(this.cockpitData, 'trendIn7', response5.data);
    },

    resizedGrid(i) {
      this.$refs['grid_' + i][0].resize();
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          return;
        }
        this.gridContainerHeight = this.$refs.container.offsetHeight - this.$refs.header.offsetHeight - 10 - 20;
        this.gridRowHeihgt = this.gridContainerHeight / 24;

        for (let index = 0; index < this.layout.length; index++) {
          let layout = this.layout[index];
          this.resizedGrid(layout.i);
        }
      }, 500);
    }
  }
};
</script>
